import { HostListener,Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as AOS from 'aos';

//jquery declaration
declare var $: any;

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.css']
})
export class NavmenuComponent implements OnInit { 

  // AOS:any;
  // public isShowNav=false;  
  public homeclass:string='';
  public isExpanded:boolean = false;
  private activeClass:string ="active";
  private inactiveClass='';
  public Home:string = this.activeClass;
  public AboutUs:string=this.inactiveClass;
  public SafetyProgram:string=this.inactiveClass;
  public SafetyTraining:string=this.inactiveClass;
  public LiveEvents:string=this.inactiveClass;
  public OurCompany:string=this.inactiveClass;
  public Contact:string=this.inactiveClass;
  public Careers:string=this.inactiveClass;
  public Blog:string=this.inactiveClass;  

  opts={
    startVal: 0,
    useEasing: true,
    duration:15
  }

  constructor(
    private router: Router
  ) { }  

  ngOnInit(): void {

    AOS.init();

    this.homeclass="margin-right:-33px";

    if ($('#preloader').length) {
      $('#preloader').delay(500).fadeOut('slow', function() {
        $(this).remove();
      });
    }

    // Smooth scroll for the navigation menu and links with .scrollto classes
    var scrolltoOffset = $('#header').outerHeight() - 2;
    $(document).on('click', '.nav-menu a, .mobile-nav a, .scrollto', function(e) {
      if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
        var target = $(this.hash);
        if (target.length) {
          e.preventDefault();

          var scrollto = target.offset().top - scrolltoOffset;

          if ($(this).attr("href") == '#header' || $(this).attr("href") == 'index.html#header') {
            scrollto = 0;
          }

          $('html, body').animate({
            scrollTop: scrollto
          }, 1500, 'easeInOutExpo');

          if ($(this).parents('.nav-menu, .mobile-nav').length) {
            $('.nav-menu .active, .mobile-nav .active').removeClass('active');
            $(this).closest('li').addClass('active');
          }

          if ($('body').hasClass('mobile-nav-active')) {
            $('body').removeClass('mobile-nav-active');
            $('.mobile-nav-toggle i').toggleClass('fa fa-bars fa fa-times');
            $('.mobile-nav-overly').fadeOut();
          }
          return false;
        }
      }
    });

    // Activate smooth scroll on page load with hash links in the url
    $(document).ready(function() {
      if (window.location.hash) {
        var initial_nav = window.location.hash;
        if ($(initial_nav).length) {
          var scrollto = $(initial_nav).offset().top - scrolltoOffset;
          $('html, body').animate({
            scrollTop: scrollto
          }, 1500, 'easeInOutExpo');
        }
      }
      
    });



    // Navigation active state on scroll
    var nav_sections = $('section');
    var main_nav = $('.nav-menu, #mobile-nav');

    $(window).on('scroll', function() {
      var cur_pos = $(this).scrollTop() + 200;

      nav_sections.each(function() {
        var top = $(this).offset().top,
          bottom = top + $(this).outerHeight();

        if (cur_pos >= top && cur_pos <= bottom) {
          if (cur_pos <= bottom) {
            main_nav.find('li').removeClass('active');
          }
          main_nav.find('a[href="#' + $(this).attr('id') + '"]').parent('li').addClass('active');
        }
        if (cur_pos < 300) {
          $(".nav-menu ul:first li:first").addClass('active');
        }
      });
    });

    // Toggle .header-scrolled class to #header when page is scrolled
    $(window).scroll(function() {
      if ($(this).scrollTop() > 100) {
        $('#header').addClass('header-scrolled');
        $('#topbar').addClass('topbar-scrolled');
      } else {
        $('#header').removeClass('header-scrolled');
        $('#topbar').removeClass('topbar-scrolled');
      }
    });

    if ($(window).scrollTop() > 100) {
      $('#header').addClass('header-scrolled');
      $('#topbar').addClass('topbar-scrolled');
    }

    // Back to top button
    $(window).scroll(function() {
      if ($(this).scrollTop() > 100) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });

    $('.back-to-top').click(function() {
      $('html, body').animate({
        scrollTop: 0
      }, 1500, 'easeInOutExpo');
      return false;
    });   
    

    // Scroll to a section with hash in url
    $(window).on('load', function() {

      if (window.location.hash) {
        var initial_nav = window.location.hash;
        if ($(initial_nav).length) {
          var target_hash = $(initial_nav);
          var scrollto_hash = target_hash.offset().top - $('#header').outerHeight();
          $('html, body').animate({
            scrollTop: scrollto_hash
          }, 1500, 'easeInOutExpo');
          $('.nav-menu .active, .mobile-nav .active').removeClass('active');
          $('.nav-menu, .mobile-nav').find('a[href="' + initial_nav + '"]').parent('li').addClass('active');
        }
      }

    });
  

    // Mobile Navigation
    if ($('.nav-menu').length) {
      var $mobile_nav = $('.nav-menu').clone().prop({
        class: 'mobile-nav d-lg-none'
      });      

      $('body').append($mobile_nav);
      $('body').prepend('<button type="button" class="mobile-nav-toggle d-lg-none mt-4"><i class="fa fa-bars"></i></button>');
      $('body').append('<div class="mobile-nav-overly"></div>');

      $(document).on('click', '.mobile-nav-toggle', function(e) {
        console.log("tatatat");
        //$("#client").show();
        if(e.target==='i.fa.fa-times')
        {
          this.homeclass="margin-right:-33px";
        }
        else{
          this.homeclass="margin-right:-33px";
        }
        
       
        $('body').toggleClass('mobile-nav-active');
        $('.mobile-nav-toggle i').toggleClass('fa fa-bars fa fa-times');
        $('.mobile-nav-overly').toggle();              
      });

      $(document).on('click', '.mobile-nav .drop-down>a', function(e) {
        $(this).next().slideToggle(300);
        $(this).parent().toggleClass('active');

        e.preventDefault();
      });      

      // $(document).on('mouseover', '.mobile-nav .drop-down', function(e) {
      //   $(this).parent().toggleClass('active');
      //   e.preventDefault();
      // });

      $(document).click(function(e) {
        var container = $(".mobile-nav, .mobile-nav-toggle");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
          if ($('body').hasClass('mobile-nav-active')) {
            $('body').removeClass('mobile-nav-active');
            $('.mobile-nav-toggle i').toggleClass('fa fa-bars fa fa-times');
            $('.mobile-nav-overly').fadeOut();           
          }
        }
      });
    } else if ($(".mobile-nav, .mobile-nav-toggle").length) {
      $(".mobile-nav, .mobile-nav-toggle").hide();      
      
    }    


    console.log($(window).width());

    // Mobile Navigation
    if ($(window).width() > 993) {
      //alert("abc");
      $("#client").hide();
    }
    else {
      $("#client").show();
    }

    

  

    this.menuClicked();
    // this.test();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {    
    event.target.innerWidth;
    //$("#client").hide();
  }

  menuClicked(){

    
    var _path=window.location.href.toString()
    var _index=_path.lastIndexOf("/")+1;
    var menu=_path.substring(_index);

    console.log(menu);

    switch(menu.toLowerCase()){
      case '':
        this.Home=this.activeClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'ourteam':
        this.Home=this.inactiveClass;
        this.AboutUs=this.activeClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'ourcompany':
        this.Home=this.inactiveClass;
        this.AboutUs=this.activeClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'safetyprogram':
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.activeClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'safetytraining':
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.activeClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'LiveEvents':
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.activeClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'contact':
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.activeClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;
      case 'careers':
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.activeClass;
        this.Blog=this.inactiveClass;
        break;
      case 'blog':
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Careers=this.inactiveClass;
        this.Blog=this.activeClass;
        break;
      default:
        this.Home=this.inactiveClass;
        this.AboutUs=this.inactiveClass;
        this.SafetyProgram=this.inactiveClass;
        this.LiveEvents=this.inactiveClass;
        this.SafetyTraining=this.inactiveClass;
        this.OurCompany=this.inactiveClass;
        this.Contact=this.inactiveClass;
        this.Blog=this.inactiveClass;
        break;

    }
  }

  topposition(){  

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    this.menuClicked();
    return false;
  }
}
